import Typography from "typography";

const typography = new Typography({ 
  baseFontSize: '18px',
  baseLineHeight: 1.35,
  bodyFontFamily: ['Nunito', 'sans-serif'],
  bodyWeight: 200,
  googleFonts: [
    {
      name: 'Dosis',
      styles: [
        '200',
        '400',
        '700',
      ]
    },
    {
      name: 'Nunito',
      styles: [
        '200',
        '300',
        '400',
      ]
    }
  ],
  headerFontFamily: ['Dosis', 'sans-serif'],
  headerWeight: '700',
  scaleRatio: 2.5,
});

export default typography;


// WEBPACK FOOTER //
// ./src/utils/typography.js